<template>
  <div class="row">
    <modal :show.sync="modalsCSV" footer-classes="justify-content-center" type="notice">
      <h3 slot="header" class="modal-title">Import CSV Form</h3>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12 text-center">
            <label id="fileName">{{ fileName }}</label>
            <span class="btn btn-info btn-file">
              <span class="fileinput-new">Choose File</span>
              <input
                id="uploadFile"
                accept=".csv"
                type="file"
                class="valid"
                :multiple="false"
                aria-invalid="false"
                @change="readFile"
              />
            </span>
          </div>
        </div>
        <div class="d-flex justify-content-center spinner" v-if="load">
          <circle-8></circle-8>
        </div>
      </div>
      <template slot="footer">
        <base-button
          @click="submitCSV"
          :disabled="CSVError"
          class="mt-3"
          native-type="submit"
          type="success"
        >Submit</base-button>&nbsp;&nbsp;&nbsp;
        <base-button class="mt-3" type="danger" @click.native="modalsCSV = false">Cancel</base-button>
      </template>
    </modal>
    <div class="col-lg text-center">
      <h4 class="card-title style-title">Vehicle Registration</h4>
      <h5
        class="description style-title"
      >Please fill in all the required details to add new Vehicle.</h5>
    </div>

    <div class="col-md-12">
      <card class="stacked-form">
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-7 ml-auto mr-auto">
              <div class="row">
                <div class="col-12">
                  <h3 style="border-bottom: solid red">Vehicle Details</h3>
                </div>
                <div class="col-md-6">
                  <base-input label="Vehicle Registration Number" v-model="regno" required></base-input>
                  <base-input
                    label="Vehicle Category"
                    placeholder="Category"
                    name="required"
                    type="text"
                    required
                  >
                    <el-select
                      class="select-info"
                      size="large"
                      placeholder="Choose..."
                      v-model="selects.selectCategory"
                    >
                      <el-option
                        v-for="dept in selects.category"
                        :value="dept.value"
                        :label="dept.label"
                        :key="dept.value"
                      ></el-option>
                    </el-select>
                  </base-input>
                  <base-input label="Vehicle Weight (BDM)" v-model="bdm"></base-input>
                  <base-input label="Vehicle Weight (BTM)" v-model="btm"></base-input>
                  <base-input label="Manufacture" v-model="manufacture"></base-input>
                  <base-input label="Road Tax / Insurance" required>
                    <el-date-picker type="date" placeholder="Date Picker" v-model="dateRoadtax"></el-date-picker>
                  </base-input>
                  <base-input label="Schedule Preventive Maintenace Date" required>
                    <el-date-picker type="date" placeholder="Date Picker" v-model="dateMaintenance"></el-date-picker>
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="Model" v-model="model"></base-input>
                  <base-input label="Size" v-model="size"></base-input>
                  <base-input label="Chassis No" v-model="chassno"></base-input>
                  <base-input label="Engine No" v-model="engine"></base-input>
                  <base-input label="Transmission Type" v-model="transport"></base-input>
                  <base-input label="Odometer" v-model="odometer" required></base-input>
                  <base-input label="PUSPAKOM Inspection Date" required>
                    <el-date-picker type="date" placeholder="Date Picker" v-model="datePUSPAKOM"></el-date-picker>
                  </base-input>
                </div>
              </div>
            </div>
            <div class="col-md-4 ml-auto mr-auto">
              <h3 style="border-bottom: solid red">Company Details</h3>
              <div class="col-md-12">
                <!-- <base-input
                  label="Department"
                  placeholder="Department"
                  name="required"
                  type="text"
                  required
                >
                  <el-select
                    class="select-info"
                    size="large"
                    placeholder="Choose..."
                    v-model="selects.selectDept"
                  >
                    <el-option
                      v-for="dept in selects.department"
                      :value="dept.value"
                      :label="dept.label"
                      :key="dept.value"
                    ></el-option>
                  </el-select>
                </base-input>-->
                <base-input label="Site" placeholder="Site" name="required" type="text" required>
                  <el-select
                    class="select-info"
                    size="large"
                    placeholder="Choose..."
                    v-model="selects.selectSite"
                  >
                    <el-option
                      v-for="site in selects.site"
                      :value="site.value"
                      :label="site.label"
                      :key="site.value"
                    ></el-option>
                  </el-select>
                </base-input>
                <base-input
                  label="Status"
                  placeholder="Status"
                  name="required"
                  type="text"
                  required
                >
                  <el-select
                    class="select-info"
                    size="large"
                    placeholder="Choose..."
                    v-model="selects.selectStatus"
                  >
                    <el-option
                      v-for="status in selects.status"
                      :value="status.value"
                      :label="status.label"
                      :key="status.value"
                    ></el-option>
                  </el-select>
                </base-input>
                <div v-if="selects.selectStatus == 2">
                  <h3 class="new-details">Additional Info</h3>
                  <base-input label="Breakdown Date" required>
                    <el-date-picker type="date" placeholder="Date Picker" v-model="dateBreakdown"></el-date-picker>
                  </base-input>
                  <base-input label="ETD Date" required>
                    <el-date-picker type="date" placeholder="Date Picker" v-model="dateETD"></el-date-picker>
                  </base-input>
                </div>
                <div v-if="selects.selectStatus == 3">
                  <h3 class="new-details">Additional Info</h3>
                  <base-input
                    label="Replacement Vehicle"
                    placeholder="Replacement Vehicle"
                    name="required"
                    type="text"
                    required
                  >
                    <el-select
                      class="select-info"
                      size="large"
                      placeholder="Choose..."
                      v-model="selects.replacementVehicle"
                    >
                      <el-option
                        v-for="vehicle in selects.vehicle"
                        :value="vehicle.value"
                        :label="vehicle.label"
                        :key="vehicle.value"
                      ></el-option>
                    </el-select>
                  </base-input>
                  <base-input label="Replacement Date" required>
                    <el-date-picker type="date" placeholder="Date Picker" v-model="dateReplacement"></el-date-picker>
                  </base-input>
                </div>
              </div>
            </div>

            <div class="col-lg-12 text-center">
              <el-link href="./img/csv/VehicleRegistration.csv" class="mt-3" type="primary">Download CSV template</el-link>
              &nbsp;
              <base-button
                @click="modalsCSV = true"
                class="mt-3"
                native-type="submit"
                type="green"
                simple
              >Import with CSV</base-button>
              <base-button
                @click="addVehicle()"
                class="mt-3"
                native-type="submit"
                type="primary"
              >Submit</base-button>
            </div>
          </div>
        </form>
      </card>
    </div>
  </div>
</template>
<script>
import { BaseCheckbox, BaseRadio, Modal } from "src/components/index";
import { TimeSelect, DatePicker, Select, Option, Link } from "element-ui";
import moment from "moment";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";

export default {
  components: {
    Modal,
    BaseCheckbox,
    [Select.name]: Select,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Option.name]: Option,
    BaseRadio,
    Circle8,
    [Link.name]: Link
  },
  data() {
    return {
      load: false,
      fileName: "",
      dateRoadtax: "",
      dateMaintenance: "",
      datePUSPAKOM: "",
      dateBreakdown: "",
      dateETD: "",
      dateReplacement: "",
      selects: {
        selectDept: "",
        selectSite: "",
        selectStatus: "",
        selectCategory: "",
        replacementVehicle: "",
        department: [],
        site: [],
        status: [],
        category: [],
        vehicle: []
      },
      regno: "",
      bdm: "",
      manufacture: "",
      btm: "",
      model: "",
      size: "",
      chassno: "",
      engine: "",
      transport: "",
      odometer: "",
      siteData: null,
      empID: "",
      payloadCSV: [],
      modalsCSV: false,
      CSVError: true,
      CSVHeader: false
    };
  },

  methods: {
    readFile(ev) {
      this.payloadCSV = [];
      let error = true;
      const file = ev.target.files[0];
      const reader = new FileReader();
      reader.readAsText(file);

      reader.onload = e => {
        let header;
        let lines = [];
        let csv = e.target.result; // Content from file
        let allTextLines = csv.split(/\r\n|\n/);
        for (let i = 0; i < allTextLines.length; i++) {
          if (i == 0) {
            header = allTextLines[i].split(",");
          } else {
            lines.push(allTextLines[i].split(","));
          }
        }
        lines.pop();
        console.log(header)
        lines.forEach(line => {
          if (line[15] == "AVAILABLE") {
            // Check header
            this.checkHeader(header, 1);

            for (let i = 0; i < 16; i++) {
              if (line[i] == "") {
                swal({
                  type: "error",
                  title: `${line[0]} missing a value!`
                });
                this.CSVHeader = true;
                this.CSVError = true;
                return;
              }
            }
          } else if (line[15] == "BREAKDOWN") {
            this.checkHeader(header, 2);

            for (let i = 0; i < 18; i++) {
              if (line[i] == "") {
                swal({
                  type: "error",
                  title: `${line[0]} missing a value!`
                });
                this.CSVHeader = true;
                this.CSVError = true;
                return;
              }
            }
          }

          if (this.CSVHeader) {
            return;
          }
          console.log("MASUK");

          let site;
          let department;
          let status;
          let empID;
          let category;

          // CHECK CATEGORY COLUMN IF ITS VALID OR NOT
          for (let i = 0; i < this.selects.category.length; i++) {
            if (line[1] == this.selects.category[i].label) {
              category = this.selects.category[i].value;
            }
          }
          if (category == undefined) {
            swal({
              title: `${line[1]} does not exist!`,
              text: "Please contact admin to add new category!",
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              cancelButtonClass: "btn btn-danger btn-fill",
              confirmButtonText: "Okay!",
              buttonsStyling: false
            });
            this.CSVError = true;
            return;
          }

          // CHECK DEPARTMENT COLUMN IF ITS VALID OR NOT
          // for (let i = 0; i < this.selects.department.length; i++) {
          //   if (line[13] == this.selects.department[i].label) {
          //     department = this.selects.department[i].value;
          //   }
          // }
          // if (department == undefined) {
          //   swal({
          //     title: `${line[13]} does not exist!`,
          //     text: "Please contact admin to add new department!",
          //     type: "warning",
          //     confirmButtonClass: "btn btn-success btn-fill",
          //     cancelButtonClass: "btn btn-danger btn-fill",
          //     confirmButtonText: "Okay!",
          //     buttonsStyling: false
          //   });
          //   this.CSVError = true;
          //   return;
          // }

          // CHECK SITE COLUMN IF ITS VALID OR NOT
          for (let i = 0; i < this.selects.site.length; i++) {
            if (line[12] == this.selects.site[i].label) {
              site = this.selects.site[i].value;
              department = this.siteData[i].DeptID
            }
          }
          if (site == undefined) {
            swal({
              title: `${line[12]} does not exist!`,
              text: "Please contact admin to add new site!",
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              cancelButtonClass: "btn btn-danger btn-fill",
              confirmButtonText: "Okay!",
              buttonsStyling: false
            });
            this.CSVError = true;
            return;
          }

          // CHECK STATUS COLUMN IF ITS VALID OR NOT
          for (let i = 0; i < this.selects.status.length; i++) {
            if (line[15] == this.selects.status[i].label) {
              status = this.selects.status[i].value;
            }
          }
          if (status == undefined) {
            swal({
              title: `${line[15]} does not exist!`,
              text: "Please contact admin to add new status!",
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              cancelButtonClass: "btn btn-danger btn-fill",
              confirmButtonText: "Okay!",
              buttonsStyling: false
            });
            this.CSVError = true;
            return;
          }

          // GET THE EMPID OF SELECTED SITE
          for (let i = 0; i < this.siteData.length; i++) {
            if (site == this.siteData[i].SiteID) {
              empID = this.siteData[i].EmpID;
            }
          }

          let body = {
            VehicleNo: line[0],
            CategoryID: category,
            Bdm: line[2],
            Btm: line[3],
            Manufacture: line[4],
            Model: line[5],
            Size: line[6],
            ChassisNo: line[7],
            EngineNo: line[8],
            TransportType: line[9],
            PuspakomDate: line[10],
            RoadTaxDate: line[11],
            SiteID: site,
            DeptID: department,
            EmpID: empID,
            Odometer: line[14],
            StatusID: status,
            MaintenanceDate: line[16],
            BreakdownDate: line[17],
            EtdDate: line[18]
          };
          this.payloadCSV.push(body);
          this.fileName = file.name;
          console.log(this.payloadCSV);
          this.CSVError = false;
        });
      };

      document.getElementById("uploadFile").value = ""; // REMOVE FILE
    },
    submitCSV() {
      this.load = true
      this.callRegisterVehicle(this.payloadCSV);
      this.modalsCSV = false;
    },

    getStatus() {
      this.$http.get(":9993/api/v1/setting/status").then(res => {
        if (!res.error) {
          let data = res.message;

          for (let i = 0; i < data.length; i++) {
            if (data[i].StatusName != "REPLACEMENT") {
              let statuses = {
                value: data[i].StatusID,
                label: data[i].StatusName
              };
              this.selects.status.push(statuses);
            }
          }

          this.selects.selectStatus = this.selects.status[0].value;
        }
      });
    },
    getCategory() {
      // get API from setting controller
      this.$http.get(":9993/api/v1/setting/category").then(res => {
        if (!res.error) {
          let data = res.message;
          console.log(data)
          for (let i = 0; i < data.length; i++) {
            let categories = {
              label: data[i].CategoryName,
              value: data[i].CategoryID
            };

            this.selects.category.push(categories);
          }
        }
      });
    },
    getSite() {
      this.$http.get(":9993/api/v1/register/site").then(res => {
        if (!res.error) {
          let data = res.message;
          this.siteData = data;
          console.log(this.siteData);

          for (let i = 0; i < data.length; i++) {
            let sites = {
              value: data[i].SiteID,
              label: data[i].SiteName
            };

            this.selects.site.push(sites);
          }
        }
      });
    },
    getDepartment() {
      this.$http.get(":9993/api/v1/setting/department").then(res => {
        if (!res.error) {
          let data = res.message;
          console.log(data)
          for (let i = 0; i < data.length; i++) {
            let departments = {
              value: data[i].DeptID,
              label: data[i].DeptName
            };

            this.selects.department.push(departments);
          }
        }
      });
    },
    callRegisterVehicle(body) {
      console.log("body", body)
      this.$http
        .post(":9993/api/v1/register/vehicle", body)
        .then(res => {
          console.log(res);
          if (!res.error) {
            swal({
              title: "Vehicle transaction completed!",
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              cancelButtonClass: "btn btn-danger btn-fill",
              confirmButtonText: "Okay!",
              buttonsStyling: false
            });
          } else {
            swal({
              title: res.message,
              type: "error",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false
            });
          }
          this.load = false
        });
    },
    addVehicle() {
      const STATUS = this.selects.selectStatus;

      if (
        this.regno == "" ||
        this.selects.selectCategory == "" ||
        this.datePUSPAKOM == "" ||
        this.dateRoadtax == "" ||
        this.selects.selectSite == "" ||
        this.odometer == "" ||
        this.dateMaintenance == ""
      ) {
        swal({
          title: "Please fill in all the form!",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Okay!",
          buttonsStyling: false
        });
      } else {
        let deptID;
        console.log(this.selects.department)
        for (let i = 0; i < this.siteData.length; i++) {
          if (this.selects.selectSite == this.siteData[i].SiteID) {
            this.empID = this.siteData[i].EmpID;
            deptID = this.siteData[i].DeptID;
          }
        }
        console.log(this.siteData)
        let body = [
          {
            VehicleNo: this.regno,
            CategoryID: this.selects.selectCategory,
            Bdm: this.bdm,
            Btm: this.btm,
            Manufacture: this.manufacture,
            Model: this.model,
            Size: this.size,
            ChassisNo: this.chassno,
            EngineNo: this.engine,
            TransportType: this.transport,
            PuspakomDate: moment(this.datePUSPAKOM).format("YYYY-MM-DD"),
            RoadTaxDate: moment(this.dateRoadtax).format("YYYY-MM-DD"),
            SiteID: this.selects.selectSite,
            DeptID: deptID,
            EmpID: this.empID,
            Odometer: this.odometer,
            StatusID: this.selects.selectStatus,
            MaintenanceDate: moment(this.dateMaintenance).format("YYYY-MM-DD")
          }
        ];

        if (STATUS == 1) {
          this.callRegisterVehicle(body);
        } else if (STATUS == 2) {
          if (this.dateETD == "" || this.dateBreakdown == "") {
            swal({
              title: "Please fill in the additional details!",
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              cancelButtonClass: "btn btn-danger btn-fill",
              confirmButtonText: "Okay!",
              buttonsStyling: false
            });
          } else {
            body[0]["breakdowndate"] = moment(this.dateBreakdown).format(
              "YYYY-MM-DD"
            );
            body[0]["etddate"] = moment(this.dateETD).format("YYYY-MM-DD");
            this.callRegisterVehicle(body);
          }
        }
      }
    },
    errorCsv() {
      swal({
        title: "CSV Header error!",
        text: "Incorrect spelling/order!",
        type: "warning",
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Okay!",
        buttonsStyling: false
      });
    },
    checkHeader(header, statusid) {
      if (statusid == 1) {
        if (header[0] != "Vehicle No") {
          this.errorCsv();
          this.CSVHeader = true;
          return;
        }
        if (header[1] != "Category") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[2] != "BDM") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[3] != "BTM") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[4] != "Manufacture") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[5] != "Model") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[6] != "Size") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[7] != "Chassis No") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[8] != "Engine No") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[9] != "Transport") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[10] != "PUSPAKOM") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[11] != "Roadtax") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[12] != "Site") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[13] != "Department") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[14] != "Odometer") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[15] != "Status") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[16] != "Maintenance") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }
      } else if (statusid == 2) {
        if (header[0] != "Vehicle No") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }
        if (header[1] != "Category") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[2] != "BDM") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[3] != "BTM") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[4] != "Manufacture") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[5] != "Model") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[6] != "Size") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[7] != "Chassis No") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[8] != "Engine No") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[9] != "Transport") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[10] != "PUSPAKOM") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[11] != "Roadtax") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[12] != "Site") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[13] != "Department") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[14] != "Odometer") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[15] != "Status") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }

        if (header[16] != "Maintenance") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }
        if (header[17] != "Breakdown") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }
        if (header[18] != "ETD") {
          this.CSVHeader = true;
          this.errorCsv();
          return;
        }
      }
    }
  },

  created() {
    this.getCategory();
    this.getSite();
    this.getStatus();
    
    this.getDepartment();
    // this.listBreakdown();
  }
};
</script>
<style lang="scss">
.new-details {
  padding-top: 2%;
  border-bottom: solid red;
}
</style>
